import type { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import { wrapApiCall } from '@/lib/axios'
import { AutoBanSettings, MemberNoShowStatus, type UpdateAutoBanSettingsPayload } from './model'

const base = '/crm/auto-ban'

export const AutoBanService = (client: AxiosInstance) => ({
  async getSettings(): Promise<AutoBanSettings> {
    const { data } = await wrapApiCall(() =>
      client.get<Record<string, unknown>>(`${base}/settings`)
    )
    return deserialize(data, AutoBanSettings)
  },

  async updateSettings(payload: UpdateAutoBanSettingsPayload): Promise<AutoBanSettings> {
    const { data } = await wrapApiCall(() =>
      client.put<Record<string, unknown>>(`${base}/settings`, payload)
    )
    return deserialize(data, AutoBanSettings)
  },

  async getMemberNoShowStatus(userId: number | string): Promise<MemberNoShowStatus> {
    const { data } = await wrapApiCall(() =>
      client.get<Record<string, unknown>>(`${base}/members/${userId}/no-show-status`)
    )
    return deserialize(data, MemberNoShowStatus)
  },
})
